export const appManageTypes = {
  FROM_SCRATCH: "fromScratch",
  FROM_EXISTING: "fromExisting",
  EDIT: "edit"
};
